// Verde vocabulary expansion — DESCRIBING theme (net-new cards).
//
// Extends the `describing` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `spanish`, so every value is unique.
//   [ spanish, english, emoji, part_of_speech, gender, example_es, example_en ]

export const VOCAB_DESCRIBING = [
  {
    theme: "describing", tier: "A1", rows: [
      ["alto", "tall", "📏", "adjective", "", "Mi hermano es muy alto.", "My brother is very tall."],
      ["bajo", "short (height)", "📐", "adjective", "", "La mesa es demasiado baja.", "The table is too low."],
      ["gordo", "fat", "🐷", "adjective", "", "El gato está un poco gordo.", "The cat is a bit fat."],
      ["delgado", "thin / slim", "🌿", "adjective", "", "Es alta y delgada.", "She's tall and slim."],
      ["joven", "young", "🧒", "adjective", "", "El profesor es muy joven.", "The teacher is very young."],
      ["guapo", "good-looking", "😎", "adjective", "", "Tu hermana es muy guapa.", "Your sister is very good-looking."],
      ["redondo", "round", "⚪", "adjective", "", "La mesa es redonda.", "The table is round."],
      ["cuadrado", "square", "🟦", "adjective", "", "La caja es cuadrada.", "The box is square."],
      ["lleno", "full", "🪣", "adjective", "", "El vaso está lleno.", "The glass is full."],
      ["vacío", "empty", "🫙", "adjective", "", "La botella está vacía.", "The bottle is empty."],
    ],
  },
  {
    theme: "describing", tier: "A2", rows: [
      ["amplio", "spacious / roomy", "🏠", "adjective", "", "El salón es muy amplio.", "The living room is very spacious."],
      ["ruidoso", "noisy", "🔊", "adjective", "", "El bar es demasiado ruidoso.", "The bar is too noisy."],
      ["silencioso", "quiet / silent", "🤫", "adjective", "", "El motor es muy silencioso.", "The engine is very quiet."],
      ["cómodo", "comfortable", "🛋️", "adjective", "", "El sofá es muy cómodo.", "The sofa is very comfortable."],
      ["incómodo", "uncomfortable", "🪑", "adjective", "", "La silla es incómoda.", "The chair is uncomfortable."],
      ["útil", "useful", "🛠️", "adjective", "", "Esta aplicación es muy útil.", "This app is very useful."],
      ["inútil", "useless", "🚯", "adjective", "", "El mando viejo es inútil.", "The old remote is useless."],
      ["moderno", "modern", "🏢", "adjective", "", "El edificio es muy moderno.", "The building is very modern."],
      ["antiguo", "old / antique", "🏛️", "adjective", "", "Tienen un reloj antiguo.", "They have an antique clock."],
      ["duro", "hard / tough", "🪵", "adjective", "", "El pan está duro.", "The bread is hard."],
    ],
  },
  {
    theme: "describing", tier: "B1", rows: [
      ["minucioso", "meticulous / thorough", "🔍", "adjective", "", "Hizo un análisis minucioso.", "He did a thorough analysis."],
      ["endeble", "flimsy / frail", "🍂", "adjective", "", "La estructura es endeble.", "The structure is flimsy."],
      ["resistente", "tough / durable", "🛡️", "adjective", "", "La tela es muy resistente.", "The fabric is very durable."],
      ["voluminoso", "bulky", "📦", "adjective", "", "El paquete es voluminoso.", "The package is bulky."],
      ["diminuto", "tiny", "🐜", "adjective", "", "Encontró un error diminuto.", "She found a tiny error."],
      ["vistoso", "eye-catching / showy", "🎨", "adjective", "", "Lleva un vestido muy vistoso.", "She's wearing a very eye-catching dress."],
      ["engorroso", "cumbersome / awkward", "🧶", "adjective", "", "El trámite es engorroso.", "The procedure is cumbersome."],
      ["versátil", "versatile", "🔧", "adjective", "", "Es una herramienta versátil.", "It's a versatile tool."],
      ["escueto", "concise / terse", "✂️", "adjective", "", "Envió un mensaje escueto.", "He sent a terse message."],
      ["nítido", "crisp / sharp (clear)", "🔭", "adjective", "", "La imagen se ve nítida.", "The image looks crisp."],
    ],
  },
];
